import { useHydrateAtoms } from 'jotai/utils';
import merge from 'lodash/merge';
import { es, enUS, fr } from 'date-fns/locale';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';

// Atoms
import { datepickerAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';

// Types
import type { DayPickerBase } from 'react-day-picker';
import type { DatepickerAtomType } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
import type { UserType } from '@/types/userType';

// Components
import { Caption } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar/components/Caption';

export type HydrateDatepickerAtomsProps = DatepickerAtomType & {
    children: React.ReactNode;
};

function getLocale(lang: UserType['settings']['platform_language']) {
    if (lang === 'es') return es;

    if (lang === 'fr') return fr;

    return enUS;
}

export function HydrateAtoms({ children, ...restProps }: HydrateDatepickerAtomsProps) {
    const defaultData: { dayPickerOptions: DayPickerBase } = {
        dayPickerOptions: {
            fixedWeeks: true,
            locale: getLocale(restProps.settings.lang),
            formatters: {
                formatWeekdayName: (date) => {
                    // Use substring to remove "." added in abbreviation for FR and ES
                    return dayjs(date)
                        .locale(restProps.settings.lang)
                        .format('ddd')
                        .substring(0, 3);
                }
            },
            components: { Caption }
        }
    };

    useHydrateAtoms([[datepickerAtom, merge({}, defaultData, restProps)] as const]);

    return children;
}
